<script lang="ts" setup>
import { ref } from 'vue';
import type { TElementSidebarEditor } from '../types';
import { useSnippet } from '../hooks/useSnippet';

type TSnippetItemProps = {
  item: TElementSidebarEditor;
  category: string;
};

const isHover = ref(false);
const { item } = defineProps<TSnippetItemProps>();
const { isDisableElement, onGoToPricingPage } = useSnippet({ item });
// handle apply drag here
const handleHoverElement = (isHoverEvent: boolean) => {
  isHover.value = isHoverEvent;
};
</script>

<template>
  <div
    class="snippet-wrap show"
    :class="{
      '!cursor-pointer': isDisableElement,
    }">
    <div
      :id="`snippet-${item.id}`"
      :tabindex="item.id"
      class="snippet cursor-none border border-transparent"
      :class="{
        isNew: item.status === 'new',
        isBeta: item.status === 'beta',
        'isNew isHide': item.status === 'test',
        isHide: item.status === 'hide',
        isNotShow: item.status === 'invisible',
        '!bg-dark-200': isDisableElement && isHover,
        '!cursor-pointer': isDisableElement,
      }"
      :data-id="item.id"
      :data-key="item.key"
      :data-ver="item.version"
      :data-cat="item.category"
      :data-type="item.data_attr.type"
      :data-label="item.label"
      :data-icon="item.data_attr?.icon"
      @mouseover="handleHoverElement(true)"
      @mouseleave="handleHoverElement(false)"
      @click="onGoToPricingPage">
      <div class="snippet-info" title="View Information" data-position="bottom">
        <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.42578 5.25V4.07422H7.57422V5.25H6.42578ZM3.69141 10.3086C4.62109 11.2201 5.72396 11.6758 7 11.6758C8.27604 11.6758 9.36979 11.2201 10.2812 10.3086C11.2109 9.37891 11.6758 8.27604 11.6758 7C11.6758 5.72396 11.2109 4.63021 10.2812 3.71875C9.36979 2.78906 8.27604 2.32422 7 2.32422C5.72396 2.32422 4.62109 2.78906 3.69141 3.71875C2.77995 4.63021 2.32422 5.72396 2.32422 7C2.32422 8.27604 2.77995 9.37891 3.69141 10.3086ZM2.87109 2.89844C4.01953 1.75 5.39583 1.17578 7 1.17578C8.60417 1.17578 9.97135 1.75 11.1016 2.89844C12.25 4.02865 12.8242 5.39583 12.8242 7C12.8242 8.60417 12.25 9.98047 11.1016 11.1289C9.97135 12.2591 8.60417 12.8242 7 12.8242C5.39583 12.8242 4.01953 12.2591 2.87109 11.1289C1.74089 9.98047 1.17578 8.60417 1.17578 7C1.17578 5.39583 1.74089 4.02865 2.87109 2.89844ZM6.42578 9.92578V6.42578H7.57422V9.92578H6.42578Z"
            fill="currentColor"></path>
        </svg>
      </div>
      <div class="snippet-icon">
        <i :class="item.data_attr?.icon"></i>
      </div>
      <span class="snippet-label"
        >{{ item.label?.replace('Collection', '(C)') }}
        <span
          v-if="isDisableElement"
          class="!ml-1 rounded-[3px] bg-green-100 !px-1 !py-[1px] text-xs font-medium text-green-500"
          >Optimize</span
        >
      </span>
      <span class="snippet-desc">{{ item.data_attr?.description }}</span>
    </div>
  </div>
</template>
<style scoped lang="scss">
.isNotShow {
  display: none;
}
</style>

<style lang="scss">
.gem-meter-highlight {
  &__button {
    position: relative;
    border-color: theme('colors.amber.300');
    &:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: theme('colors.amber.300');
      animation-name: blink;
      animation-duration: 0.8s;
      animation-iteration-count: 3;
      border-radius: 4px;
    }
  }
  &__3rd-party {
    position: relative !important;
    border-color: theme('colors.amber.300');
    &:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: theme('colors.amber.300');
      animation-name: blink;
      animation-duration: 0.8s;
      animation-iteration-count: 3;
      border-radius: 4px;
    }
  }
}
@keyframes blink {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.3;
  }
}
</style>
